// Loading
export const SET_LOADING_FALSE = "SET_LOADING_FALSE";
export const SET_LOADING_TRUE = "SET_LOADING_TRUE";
export const SET_POPUP_LOGIN_TRUE = "SET_POPUP_LOGIN_TRUE";
export const SET_POPUP_LOGIN_FALSE = "SET_POPUP_LOGIN_FALSE";

// Order
export const SET_ORDER_FORM_VALUE = "SET_ORDER_FORM_VALUE";
export const SET_PROFILE_FORM_VALUE = "SET_PROFILE_FORM_VALUE";
export const SET_PEKERJAAN = "SET_PEKERJAAN";
export const SET_JENIS_KENDARAAN = "SET_JENIS_KENDARAAN";
export const SET_JENIS_PEMBIAYAAN = "SET_JENIS_PEMBIAYAAN";
export const SET_JENIS_PRODUK = "SET_JENIS_PRODUK";
export const SET_JENIS_KEGIATAN_USAHA = "SET_JENIS_KEGIATAN_USAHA";
export const SET_TRANSAKSI_PAYLOAD = "SET_TRANSAKSI_PAYLOAD";
export const SET_UPDATED_TRANSAKSI = "SET_UPDATED_TRANSAKSI";
export const SET_LIST_CRO = "SET_LIST_CRO";
export const SET_ORDER_FORM_ID = "SET_ORDER_FORM_ID";
export const SET_JENIS_JAMINAN = "SET_JENIS_JAMINAN";
export const SET_DAFTAR_CABANG = "SET_DAFTAR_CABANG";
export const SET_DAFTAR_AREA = "SET_DAFTAR_AREA";
export const SET_CABANG_AREA = "SET_CABANG_AREA";
export const SET_BRAND_TYPE_MODEL = "SET_BRAND_TYPE_MODEL";
export const SET_VEHICLE_BRAND = "SET_VEHICLE_BRAND";
export const SET_VEHICLE_YEAR = "SET_VEHICLE_YEAR";
export const SET_KELURAHAN = "SET_KELURAHAN";
export const SET_SUBMIT_STATUS = "SET_SUBMIT_STATUS";
export const SET_LAST_RESPONSE = "SET_LAST_RESPONSE";
export const SET_FIRST_SIMULATION_STATUS = "SET_FIRST_SIMULATION_STATUS";
export const SET_FIRST_SIMULATION_RESULT = "SET_FIRST_SIMULATION_RESULT";
export const SET_SECOND_SIMULATION_STATUS = "SET_SECOND_SIMULATION_STATUS";
export const SET_SECOND_SIMULATION_RESULT = "SET_SECOND_SIMULATION_RESULT";
export const SET_DATA_AXI = "SET_DATA_AXI";

// Area
export const SET_AREAS = "SET_AREAS";
export const SET_PROVINCES = "SET_PROVINCES";
export const SET_CITIES = "SET_CITIES";
export const SET_DISTRICTS = "SET_DISTRICTS";
export const SET_VILLAGES = "SET_VILLAGES";
export const SET_BRANCHES = "SET_BRANCHES";
export const SET_BRANCHES_BY_ID = "SET_BRANCHES_BY_ID";
export const SET_BRANCHES_BY_AREAID = "SET_BRANCHES_BY_AREAID";

// Simulasi
export const SET_VEHICLE_TYPES = "SET_VEHICLE_TYPE";
export const SET_VEHICLE_BRANDS = "SET_VEHICLE_BRAND";
export const SET_VEHICLE_MODELS = "SET_VEHICLE_MODELS";
export const SET_SIMULATION = "SET_SIMULATION";
export const DELETE_SIMULATION = "DELETE_SIMULATION";

// Auth
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const LOGOUT_FAILED = "LOGOUT_FAILED";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILED = "REGISTER_FAILED";
export const FORGOT_SUCCESS = "FORGOT_SUCCESS";
export const FORGOT_FAILED = "FORGOT_FAILED";
export const RESET_SUCCESS = "RESET_SUCCESS";
export const RESET_FAILED = "RESET_FAILED";
export const DETAIL_AXI = "DETAIL_AXI";
export const DETAIL_AXI_INSENTIF = "DETAIL_AXI_INSENTIF";
export const SET_PROFILE = "SET_PROFILE";
export const SET_BANKS = "SET_BANKS";
export const SET_USER = "SET_USER";
export const SET_RELIGIONS = "SET_RELIGIONS";
export const SET_STATUS = "SET_STATUS";
export const SET_GENDERS = "SET_GENDERS";
export const SET_LEGAL_FORM = "SET_LEGAL_FORM";

export const SET_AXI_ID = "SET_AXI_ID";

// Content
export const SET_TESTIMONIES = "SET_TESTIMONIES";
export const SET_ARTICLES = "SET_ARTICLES";
export const SET_ARTICLES_META = "SET_ARTICLES_META";
export const SET_MATERI = "SET_MATERI";
export const SET_ARTICLE_DETAIL = "SET_ARTICLE_DETAIL";
export const SET_CATEGORY_DETAIL = "SET_CATEGORY_DETAIL";
export const SET_ARTICLES_POPULAR = "SET_ARTICLES_POPULAR";
export const SET_ARTICLES_POPULAR_META = "SET_ARTICLES_POPULAR_META";
export const SET_BANNER = "SET_BANNER";
export const SET_BANNER_PROFILE = "SET_BANNER_PROFILE";
export const SET_BANNER_PRODUK_PEMBIAYAAN = "SET_BANNER_PRODUK_PEMBIAYAAN";
export const SET_BANNER_SIMULASI_CICILAN = "SET_BANNER_SIMULASI_CICILAN";
export const SET_BANNER_MITRA_MAXI = "SET_BANNER_MITRA_MAXI";
export const SET_BANNER_AXI = "SET_BANNER_AXI";
export const SET_BANNER_GUDANG_INFO = "SET_BANNER_GUDANG_INFO";
export const SET_BANNER_KEBIJAKAN_PRIVACY = "SET_BANNER_KEBIJAKAN_PRIVACY";
export const SET_BANNER_MAXI_TRAVEL = "SET_BANNER_MAXI_TRAVEL";
export const SET_BANNER_MAXI_EDUKASI = "SET_BANNER_MAXI_EDUKASI";
export const SET_BANNER_MAXI_USAHA = "SET_BANNER_MAXI_USAHA";
export const SET_BANNER_MAXI_SEHAT = "SET_BANNER_MAXI_SEHAT";
export const SET_BANNER_MAXI_GRIYA = "SET_BANNER_MAXI_GRIYA";
export const SET_BANNER_MAXI_EXTRAGUNA = "SET_BANNER_MAXI_EXTRAGUNA";
export const SET_BANNER_DANA_TUNAI_LANDSCAPE = "SET_BANNER_DANA_TUNAI_LANDSCAPE";
export const SET_BANNER_DANA_TUNAI_PORTRAIT = "SET_BANNER_DANA_TUNAI_PORTRAIT";
export const SET_BANNER_MITRA_BISNIS_LANDSCAPE = "SET_BANNER_MITRA_BISNIS_LANDSCAPE";
export const SET_BANNER_MITRA_BISNIS_PORTRAIT = "SET_BANNER_MITRA_BISNIS_PORTRAIT";

// Product
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_SUBPRODUCTS = "SET_SUBPRODUCTS";
export const SET_SUBPRODUCTSNEWS = "SET_SUBPRODUCTSNEWS";
export const SET_SUBPRODUCTS_DETAIL = "SET_SUBPRODUCTS_DETAIL";
export const SET_KEYWORD = "SET_KEYWORD";
export const SET_TAG = "SET_TAG";

// Transaksi
export const SET_TRANSAKSI = "SET_TRANSAKSI";

// AXI
export const REKAN_BISNIS = "REKAN_BISNIS";
export const LEVEL_ID = "LEVEL_ID";
export const JENIS_AXI = "JENIS_AXI";
export const AXI_FROM_ID = "AXI_FROM_ID";
export const SET_AXI_DETAIL = "SET_AXI_DETAIL";
export const JENIS_KARYAWAN = "JENIS_KARYAWAN";
export const SET_SNK_PDF = "SET_SNK_PDF";

// SAP
export const SET_AREAS_SAP = "SET_AREAS_SAP";
export const SET_PROVINCES_SAP = "SET_PROVINCES_SAP";
export const SET_CITIES_SAP = "SET_CITIES_SAP";
export const SET_DISTRICTS_SAP = "SET_DISTRICTS_SAP";
export const SET_VILLAGES_SAP = "SET_VILLAGES_SAP";
export const SET_BRANCHES_SAP = "SET_BRANCHES_SAP";
export const SET_BRANCHES_BY_ID_SAP = "SET_BRANCHES_BY_ID_SAP";
export const SET_BRANCHES_BY_AREAID_SAP = "SET_BRANCHES_BY_AREAID_SAP";
export const SET_AREAS_SAP_BY_ID = "SET_AREAS_SAP_BY_ID";
export const SET_PROVINCES_SAP_BY_ID = "SET_PROVINCES_SAP_BY_ID";
export const SET_CITIES_SAP_BY_ID = "SET_CITIES_SAP_BY_ID";
export const SET_DISTRICTS_SAP_BY_ID = "SET_DISTRICTS_SAP_BY_ID";
export const SET_PROFILE_ID = "SET_PROFILE_ID";
export const SET_RESULT_REVISI = "SET_RESULT_REVISI";
export const SET_THIRD_PARTY_SETTING = "SET_THIRD_PARTY_SETTING";
export const SET_THIRD_PARTY_PAGE_SETTING = "SET_THIRD_PARTY_PAGE_SETTING";
export const SET_BRANCH_BY_POSTALCODE_SAP = "SET_BRANCH_BY_POSTALCODE_SAP";

//Reporting
export const SET_LIST_REPORT_PPD = "SET_LIST_REPORT_PPD";

// Token Post Kode Grab
export const TOKEN_GRAB =
  "";
export const TOKEN_POST_GRAB =
  "";
export const TOKEN_REVISI =
  "";
export const TOKEN_ASSIGN_SUERVEYOR =
  "";
export const TOKEN_POST_GRAB_UAT =
  "";
export const TOKEN_FLASHDEAL =
  "";
export const TOKEN_SUPER_AXI =
  "";
